import { Button, Form, Modal, Row, Col, Typography } from 'antd';
import React, { useState } from 'react';
import DispatchCheckerService from '../../../services/Dispatch-Checker/DispatchCheckerService';
import ResponseMessage from '../../Comman/Notification/ResponseMessge';

const SelectPrototype = ({
  prototypeForm,
  parts = [],
  defects = [],
  onValuesChange,
  onSave,
  imageType,
  onClear,
}) => {
  const [quantity, setQuantity] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalType, setModalType] = useState('');
  const [modalData, setModalData] = useState([]);
  const [isFormComplete, setIsFormComplete] = useState(false);

  const handleItemSelect = (value) => {
    console.log("Selected part ID:", value);
    prototypeForm.setFieldsValue({ part: value });
    setIsModalVisible(false);
    const updatedValues = prototypeForm.getFieldsValue();
    console.log("Updated form values after part select:", updatedValues);
    onValuesChange({ part: value }, updatedValues);
    setIsFormComplete(!!updatedValues.part && !!updatedValues.defect);
  };

  const handleDefectSelect = (value) => {
    console.log("Selected defect ID:", value);
    prototypeForm.setFieldsValue({ defect: value });
    setIsModalVisible(false);
    const updatedValues = prototypeForm.getFieldsValue();
    console.log("Updated form values after defect select:", updatedValues);
    onValuesChange({ defect: value }, updatedValues);
    setIsFormComplete(!!updatedValues.part && !!updatedValues.defect);
  };

  const handleSaveClick = () => {
    console.log("Save button clicked");
    const values = prototypeForm.getFieldsValue();
    console.log("Form Values (IDs):", values);
    onSave({ ...values, quantity });
    ResponseMessage.success("Added");
  };

  const handleUndoClick = async () => {
    try {
      const response = await DispatchCheckerService.udo_eol_operations();
      console.log("Undo API response:", response.data);
      if (response.data.status) {
        ResponseMessage.success(response.data.message);
      } else {
        ResponseMessage.error(response.data.message || "Failed to undo the last entry.");
      }
    } catch (error) {
      console.error("Error in undo operation:", error);
      ResponseMessage.error("An error occurred while undoing the last entry.");
    }
  };

  const handleClearClick = () => {
    console.log("Clear button clicked");
    prototypeForm.resetFields();
    setQuantity(1);
    prototypeForm.setFieldsValue({ quantity: 1 });
    onValuesChange({}, {});
    setIsFormComplete(false); // Ensure Save is disabled after clear
    onClear(); // Trigger parent clear logic to reset displayedDataList and enable Pass button
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      prototypeForm.setFieldsValue({ quantity: newQuantity });
      console.log("Decremented to:", newQuantity);
    }
  };

  const handleIncrement = () => {
    if (quantity < 9) {
      const newQuantity = quantity + 1;
      setQuantity(newQuantity);
      prototypeForm.setFieldsValue({ quantity: newQuantity });
      console.log("Incremented to:", newQuantity);
    }
  };

  const handleValuesChange = (changedValues, allValues) => {
    console.log("Form values changed:", changedValues, allValues);
    onValuesChange(changedValues, allValues);
    setIsFormComplete(!!allValues.part && !!allValues.defect); // Update on any change
  };

  const renderModalContent = () => {
    let title = '';
    let data = [];
    let handleSelect = null;

    switch (modalType) {
      case 'part':
        title = 'Select Part';
        data = parts;
        handleSelect = handleItemSelect;
        break;
      case 'defect':
        title = 'Select Defect';
        data = defects;
        handleSelect = handleDefectSelect;
        break;
      default:
        return null;
    }

    return (
      <div style={{ padding: '20px' }}>
        <Row gutter={[16, 16]}>
          {data.map((item, index) => (
            <Col xs={12} sm={6} md={6} lg={6} key={item[Object.keys(item)[0]]}>
              <Button
                style={{
                  width: '100%',
                  height: '60px',
                  textAlign: 'center',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0 8px',
                  border: '2px solid #000000',
                  borderRadius: '4px',
                }}
                onClick={() => handleSelect(item[Object.keys(item)[0]])}
              >
                {item[Object.keys(item)[1]] || item[Object.keys(item)[0]]}
              </Button>
            </Col>
          ))}
        </Row>
        <div style={{ marginTop: '20px', textAlign: 'right' }}>
          <Typography.Text strong>NOS: {quantity}</Typography.Text>
        </div>
      </div>
    );
  };

  return (
    <Form form={prototypeForm} layout="vertical" onValuesChange={handleValuesChange}>
      <Form.Item label={<strong>PART</strong>} name="part">
        <Button
          style={{ width: 240 }}
          onClick={() => {
            setModalType('part');
            setModalData(parts);
            setIsModalVisible(true);
          }}
        >
          {prototypeForm.getFieldValue('part')
            ? parts.find(p => p.part_id === prototypeForm.getFieldValue('part'))?.part_name
            : 'Select Part'}
        </Button>
      </Form.Item>

      <Form.Item label={<strong>DEFECT</strong>} name="defect">
        <Button
          style={{ width: 240 }}
          onClick={() => {
            setModalType('defect');
            setModalData(defects);
            setIsModalVisible(true);
          }}
        >
          {prototypeForm.getFieldValue('defect')
            ? defects.find(d => d.def_id === prototypeForm.getFieldValue('defect'))?.def_name
            : 'Select Defect'}
        </Button>
      </Form.Item>

      <div style={{ marginTop: "15px", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "10px" }}>
        <span style={{ fontSize: "16px", fontWeight: "bold", marginRight: "10px" }}>NOS:</span>
        <Button type="default" size="small" onClick={handleDecrement} disabled={quantity === 1}>-</Button>
        <span style={{ fontSize: "16px", fontWeight: "bold", padding: "0 10px" }}>{quantity}</span>
        <Button type="default" size="small" onClick={handleIncrement} disabled={quantity === 9}>+</Button>
      </div>

      <Form.Item>
        <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "20px", alignItems: "center" }}>
          {/* <Button type="default" danger style={{ backgroundColor: "#ff4d4f", color: "white", padding: "0 15px" }} onClick={handleUndoClick}>
            Undo
          </Button> */}
          <Button type="primary" style={{ backgroundColor: "#52c41a", color: "white", padding: "0 15px" }} onClick={handleClearClick}>
            Clear
          </Button>
          <Button
            type="primary"
            style={{ backgroundColor: "#1890ff", color: "white", padding: "0 15px" }}
            onClick={handleSaveClick}
            disabled={!isFormComplete}
          >
            Save
          </Button>
        </div>
      </Form.Item>

      <Modal
        title={modalType ? `Select ${modalType.charAt(0).toUpperCase() + modalType.slice(1)}` : ''}
        open={isModalVisible}
        onOk={() => setIsModalVisible(false)}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={800}
        style={{ zIndex: 1000 }}
      >
        {renderModalContent()}
      </Modal>
    </Form>
  );
};

export default SelectPrototype;